var _classCallCheck = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/*! multistream. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
var stream = require('readable-stream');

function toStreams2Obj(s) {
  return toStreams2(s, {
    objectMode: true,
    highWaterMark: 16
  });
}

function toStreams2Buf(s) {
  return toStreams2(s);
}

function toStreams2(s, opts) {
  if (!s || typeof s === 'function' || s._readableState) return s;
  var wrap = new stream.Readable(opts).wrap(s);

  if (s.destroy) {
    wrap.destroy = s.destroy.bind(s);
  }

  return wrap;
}

var MultiStream = /*#__PURE__*/function (_stream$Readable) {
  "use strict";

  _inherits(MultiStream, _stream$Readable);

  var _super = _createSuper(MultiStream);

  function MultiStream(streams, opts) {
    var _this;

    _classCallCheck(this, MultiStream);

    _this = _super.call(this, opts);
    _this.destroyed = false;
    _this._drained = false;
    _this._forwarding = false;
    _this._current = null;
    _this._toStreams2 = opts && opts.objectMode ? toStreams2Obj : toStreams2Buf;

    if (typeof streams === 'function') {
      _this._queue = streams;
    } else {
      _this._queue = streams.map(_this._toStreams2);

      _this._queue.forEach(function (stream) {
        if (typeof stream !== 'function') _this._attachErrorListener(stream);
      });
    }

    _this._next();

    return _this;
  }

  _createClass(MultiStream, [{
    key: "_read",
    value: function _read() {
      this._drained = true;

      this._forward();
    }
  }, {
    key: "_forward",
    value: function _forward() {
      if (this._forwarding || !this._drained || !this._current) return;
      this._forwarding = true;
      var chunk;

      while (this._drained && (chunk = this._current.read()) !== null) {
        this._drained = this.push(chunk);
      }

      this._forwarding = false;
    }
  }, {
    key: "destroy",
    value: function destroy(err) {
      if (this.destroyed) return;
      this.destroyed = true;
      if (this._current && this._current.destroy) this._current.destroy();

      if (typeof this._queue !== 'function') {
        this._queue.forEach(function (stream) {
          if (stream.destroy) stream.destroy();
        });
      }

      if (err) this.emit('error', err);
      this.emit('close');
    }
  }, {
    key: "_next",
    value: function _next() {
      var _this2 = this;

      this._current = null;

      if (typeof this._queue === 'function') {
        this._queue(function (err, stream) {
          if (err) return _this2.destroy(err);
          stream = _this2._toStreams2(stream);

          _this2._attachErrorListener(stream);

          _this2._gotNextStream(stream);
        });
      } else {
        var stream = this._queue.shift();

        if (typeof stream === 'function') {
          stream = this._toStreams2(stream());

          this._attachErrorListener(stream);
        }

        this._gotNextStream(stream);
      }
    }
  }, {
    key: "_gotNextStream",
    value: function _gotNextStream(stream) {
      var _this3 = this;

      if (!stream) {
        this.push(null);
        this.destroy();
        return;
      }

      this._current = stream;

      this._forward();

      var onReadable = function onReadable() {
        _this3._forward();
      };

      var onClose = function onClose() {
        if (!stream._readableState.ended) {
          _this3.destroy();
        }
      };

      var onEnd = function onEnd() {
        _this3._current = null;
        stream.removeListener('readable', onReadable);
        stream.removeListener('end', onEnd);
        stream.removeListener('close', onClose);

        _this3._next();
      };

      stream.on('readable', onReadable);
      stream.once('end', onEnd);
      stream.once('close', onClose);
    }
  }, {
    key: "_attachErrorListener",
    value: function _attachErrorListener(stream) {
      var _this4 = this;

      if (!stream) return;

      var onError = function onError(err) {
        stream.removeListener('error', onError);

        _this4.destroy(err);
      };

      stream.once('error', onError);
    }
  }]);

  return MultiStream;
}(stream.Readable);

MultiStream.obj = function (streams) {
  return new MultiStream(streams, {
    objectMode: true,
    highWaterMark: 16
  });
};

module.exports = MultiStream;